<template>

  <div v-if="show" class="m-error-page">
    <div
      class="m-error-page__img"
      :class="'m-error-page__img--' + type"
    >
    </div>
    <div class="m-error-page__txt">{{content}}</div>
  </div>
</template>

<script>
export default {
  name: "MErrorPage",

  props: {
    type: {
      type: String,
      default: "default"
    },

    show: {
      type: Boolean,
      default: false
    },

    content: {
      type: String,
      default: '暂无数据'
    },
  }
};
</script>

<style lang="less">

.m-error-page{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &__img{
    background: no-repeat;
    background-size: cover;

    &--default{
      width: 172px;
      height: 60px;
      background-image: url(https://bqq.gtimg.com/qidian-stellaris-mobile/public-assets/contact-selector/nodata_default.png)
    }

    // &--troop{
    //   width: 3.2rem;
    //   height: 2.6667rem;
    //   background-image: url(https://bqq.gtimg.com/qidian-stellaris-mobile/public-assets/contact-selector/nodata_troop.png)
    // }
  }

  &__txt{
    margin-top: 15px;
    line-height: 46px;
    font-size: 23px;
    color: #000000;
    text-align: center;
  }
}
</style>
